import { equals } from 'ramda';
import { Children, cloneElement, memo, ReactElement, ReactNode } from 'react';
import { SpotPriceMetaItem, SpotPriceMetaItemProps } from './SpotPriceMetaItem';
import { TitleMetaItem } from './TitleMetaItem';

export interface TitleMetaProps {
  onDark?: boolean;
  children?: ReactNode;
}

function TitleMetaMemo({ onDark, children }: Readonly<TitleMetaProps>): ReactElement<TitleMetaProps> {
  return (
    <ul className="m-0 flex list-none sm:flex-wrap justify-evenly gap-y-2 p-2 text-right sm:justify-end xl:flex-nowrap">
      {Children.map(children, (child) => {
        if (
          child &&
          typeof child === 'object' &&
          'type' in child &&
          (child.type === TitleMetaItem || child.type === SpotPriceMetaItem)
        ) {
          return cloneElement(child as ReactElement<SpotPriceMetaItemProps>, { onDark });
        }
        return child;
      })}
    </ul>
  );
}

export const TitleMeta = memo(TitleMetaMemo, equals);
